module.exports = __webpack_public_path__ + "a34980ddd5a0d53b1dcdf0cdee1f9260.jpg";